module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8976ee64ef97be664426fa51a779489b.gif";